import styled from 'styled-components';

import IconButton from '../../../../components/IconButton';

const StyledRefreshButton = styled(IconButton)`
  margin-left: 0.5rem;
`;

export default StyledRefreshButton;
